import { EXPORTING_EXCEL, EXPORT_EXCEL, TOGGLE_EXPORT_MSG } from '../../commons/reducer';
import store from '../../index';

export default function (filters = {}, path = '', fileName = '', socketId = '') {
  const lng = localStorage.getItem('language') || 'es';
  const stateSocketId = store.getState()?.app?.socketId;
  const finalSocketId = socketId || stateSocketId || '';
  store.dispatch({
    type: EXPORT_EXCEL,
    filters: { ...filters, lng },
    path,
    fileName,
    socketId: finalSocketId,
  });
  store.dispatch({
    type: EXPORTING_EXCEL,
  });
  store.dispatch({
    type: TOGGLE_EXPORT_MSG,
  });
}
